import { render } from "./CheckCenter.vue?vue&type=template&id=05959fe6&scoped=true"
import script from "./CheckCenter.vue?vue&type=script&lang=js"
export * from "./CheckCenter.vue?vue&type=script&lang=js"

import "./CheckCenter.vue?vue&type=style&index=0&id=05959fe6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05959fe6"],['__file',"src/views/h5/common/approval/CheckCenter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05959fe6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05959fe6', __exports__)) {
    api.reload('05959fe6', __exports__)
  }
  
  module.hot.accept("./CheckCenter.vue?vue&type=template&id=05959fe6&scoped=true", () => {
    api.rerender('05959fe6', render)
  })

}


export default __exports__